import { render, staticRenderFns } from "./HotArticles.vue?vue&type=template&id=1b4fd42c&scoped=true&"
import script from "./HotArticles.vue?vue&type=script&lang=js&"
export * from "./HotArticles.vue?vue&type=script&lang=js&"
import style0 from "./HotArticles.vue?vue&type=style&index=0&id=1b4fd42c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4fd42c",
  null
  
)

export default component.exports